import { useRef, useEffect, useState, useMemo } from 'react'
import moment from 'moment-timezone';
import '../styles.css'
import { Helmet } from "react-helmet";
import { apiUrl } from '../constants'
import axios from 'axios'
import { Box, Grid, Card, Tooltip, Stack, Typography, useTheme, Button, TextField } from "@mui/material";
import { tokens } from "../theme";
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Slide
} from "@mui/material";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useSelector } from 'react-redux';
import useCheckToken from '../hooks/useCheckToken';
import useExchangeToken from "../hooks/useExchangeToken";
import Circular from "../components/model/Circular";
import LensIcon from '@mui/icons-material/Lens';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Backdrop from '@mui/material/Backdrop';
import { useParams } from 'react-router-dom'



const pause_detail = [
    {
        value: "Breakdown",
        label: "Breakdown"
    },
    {
        value: "Minor",
        label: "Minor"
    },
    {
        value: "Break",
        label: "Break"
    },
    {
        value: "Change Product",
        label: "Change Product"
    },
    {
        value: "Cleaning",
        label: "Cleaning"
    },
    {
        value: "Material Shortage",
        label: "Material Shortage"
    },
    {
        value: "Quality",
        label: "Quality"
    },
    {
        value: "RD",
        label: "RD"
    },
    {
        value: "Other",
        label: "Other"
    },
]

const shift_detail = [
    {
        value: "AM",
        label: "AM"
    },
    {
        value: "PM",
        label: "PM"
    },
]

const getPauseColor = (status) => {
    switch (status) {
        case "Breakdown":
            return "#E8453C"; // แดง

        case "Minor":
            return "#e46c0b"; // ส้ม

        case "Break":
        case "Change Product":
        case "Cleaning":
        case "Material Shortage":
        case "Quality":
        case "RD":
        case "Other":
            return "#ffeb3b"; // เหลือง

        default:
            return "#e2e2e2";
    }
};



const StatusLineInInfeed = () => {
    const { plant, factory, line } = useParams();
    const exchangeToken = useExchangeToken();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const today = new Date();
    const hourago = new Date(today.getTime());
    const datetime = moment(hourago).tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss');
    const date = moment(hourago).tz('Asia/Bangkok').format('YYYY-MM-DD');

    const [status_preparation_zone, setStatus_preparation_zon] = useState([])
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [done, setDone] = useState(false);
    const [popupTimeout, setPopupTimeout] = useState(false);
    const [openPopupTimeout, setOpenPopupTimeout] = useState(false);
    const [openPopupRun, setOpenPopupRun] = useState(false);
    const [openPopupPause, setOpenPopupPause] = useState(false);
    const [openPopupStop, setOpenPopupStop] = useState(false);

    const [editStatus, setEditStatus] = useState(false);
    const [historyInRun, setHistoryInRun] = useState({});
    const [historyInPause, setHistoryInPause] = useState({});
    const [historyInStop, setHistoryInStop] = useState({});

    const [historySelectedPause, setHistorySelectedPause] = useState('');

    const [openSelectPause, setOpenSelectPause] = useState(false);

    const [isTokenExchanged, setIsTokenExchanged] = useState(false);
    const [pauseRemark, setPauseRemark] = useState();
    const [submitted, setSubmitted] = useState(false);

    const display = useSelector(state => state.auth.email);

    const remarkRequiredStatus = [
        "Material Shortage",
        "Quality",
        "Other",
        "Minor",
        "Breakdown",
    ];

    const remarkVisibleStatus = [
        "Breakdown",
        "Minor",
        "Break",
        "Change Product",
        "Cleaning",
        "Material Shortage",
        "Quality",
        "Other",
    ];

    const isRemarkRequired = remarkRequiredStatus.includes(historySelectedPause);
    const isRemarkVisible = remarkVisibleStatus.includes(historySelectedPause);

    const handleClosePopupTimeout = () => {
        setOpenPopupTimeout(false);
    };

    const handleOpenPopupRun = () => {
        setOpenPopupRun(true);
    };
    const handleClosePopupRun = () => {
        setOpenPopupRun(false);
    };
    const handleOpenPopupPause = () => {
        setOpenPopupPause(true);
    };
    const handleClosePopupPause = () => {
        setOpenPopupPause(false);
        setHistorySelectedPause('');
        setPauseRemark('');
        setSubmitted(false);
    };
    const handleOpenPopupStop = () => {
        setOpenPopupStop(true);
    };
    const handleClosePopupStop = () => {
        setOpenPopupStop(false);
    };

    const handleCloseSelectPause = () => {
        setOpenSelectPause(false);
    };

    const handleOpenSelectPause = () => {
        setOpenSelectPause(true);
    };

    useCheckToken();
    const ac_token = useSelector(state => state.auth.access_token);


    useEffect(() => {
        const fetchInitialTokenAndData = async () => {
            try {
                const token = await exchangeToken();
                if (token) {
                    setIsTokenExchanged(true);
                }
            } catch (err) {
                console.error("Error exchanging token:", err);
                setError("Failed to exchange token");
            }
        };

        fetchInitialTokenAndData();
    }, [exchangeToken]);


    useEffect(() => {
        const fetchMyAPI = async () => {
            setLoading(true);
            const timeout = 10000;
            const timeoutError = new Promise((_, reject) =>
                setTimeout(() => reject(new Error("Request timed out")), timeout)
            );
            try {
                setDone(true);
                const response = await Promise.race([
                    axios.get(`${apiUrl.GET_TUMBLER_STATUS}plant_id=${plant}&factory=00000000000000`, {
                        headers: {
                            Authorization: `Bearer ${ac_token}`,
                        },
                    }),
                    timeoutError
                ]);
                if (response.status === 200) {
                    const fetchedData = response.data;


                    if (Array.isArray(fetchedData) && fetchedData.length === 0) {
                        console.log("No data available.");
                        setStatus_preparation_zon([]);
                    } else if (typeof fetchedData === 'string') {

                        const correctedJsonString = fetchedData.replace(/NaN/g, 'null');
                        const arrayOfObjects = JSON.parse(correctedJsonString);
                        setStatus_preparation_zon(arrayOfObjects);
                    } else {
                        setStatus_preparation_zon(fetchedData);
                    }
                    setDone(false);
                    setPopupTimeout(1);
                }
            } catch (err) {
                if (err.message === "Request timed out") {
                    console.error("Timeout Error: The request took too long to complete.");
                } else if (err.request.status === 404) {
                    setPopupTimeout(2)
                } else {
                    setPopupTimeout(3)
                }
                setDone(false);
            } finally {
                setLoading(false);
            }
        };

        if (isTokenExchanged && ac_token) {
            fetchMyAPI();
        }
    }, [isTokenExchanged]);

    status_preparation_zone.sort((a, b) => {
        const numA = parseInt(a.LINE.replace(/\D/g, ""));
        const numB = parseInt(b.LINE.replace(/\D/g, ""));
        return numA - numB;
    });

    const check_update = async () => {
        await axios.get(`${apiUrl.GET_TUMBLER_STATUS}plant_id=${plant}&factory=00000000000000`, {
            headers: {
                Authorization: `Bearer ${ac_token}`,
            },
        }
        )
            .then(response => {
                if (response.status == 200) {
                    const fetchedData = response.data;

                    if (Array.isArray(fetchedData) && fetchedData.length === 0) {
                        console.log("No data available.");
                        setStatus_preparation_zon([]);
                    } else if (typeof fetchedData === 'string') {

                        const correctedJsonString = fetchedData.replace(/NaN/g, 'null');
                        const arrayOfObjects = JSON.parse(correctedJsonString);
                        setStatus_preparation_zon(arrayOfObjects);
                    } else {
                        setStatus_preparation_zon(fetchedData);
                    }
                }
            })
            .catch(error => {
                console.log('error: ', error)
            })
    }


    const handleEditStatusRun = () => {
        setTimeout(() => {
            axios.post(`${apiUrl.PUT_TUMBLER_STATUS}`, {
                "country": "Thailand",
                "plant_id": plant,
                "factory": "00000000000000",
                "line": historyInRun?.LINE || '',
                "status": "Run",
                "factory_date": date,
                "timestamp": datetime
            }, {
                headers: {
                    Authorization: `Bearer ${ac_token}`,
                },
            })
                .then(response => {
                    // console.log(response)
                    if (response.status == 201) {
                        setEditStatus(1)
                        check_update()
                    }
                })
                .catch(error => {
                    if (error.request.status === 400) {
                        setEditStatus(2)
                    }
                    else {
                        setEditStatus(2)
                    }
                    console.log('edit status error: ', error);
                })
        });
    }

    const autoCompleteProcessingByLine = async (targetLine) => {
        if (!targetLine || !ac_token) return {
            successCount: 0,
            failCount: 0,
        };

        try {
            const today = new Date();
            const hourago = new Date(today.getTime());
            const hourago_start = new Date(today.getTime() - (48 * 60 * 60 * 1000));

            const date_start = moment(hourago_start)
                .tz("Asia/Bangkok")
                .format("YYYY-MM-DD");

            const date_end = moment(hourago)
                .tz("Asia/Bangkok")
                .format("YYYY-MM-DD");

            const completeDatetime = moment(hourago)
                .tz("Asia/Bangkok")
                .format("YYYY-MM-DD HH:mm:ss");

            const response = await axios.get(
                `${apiUrl.GET_TUMBLER_BETWEEN_2DAY}${plant}/00000000000000/${date_start}/${date_end}/`,
                {
                    headers: {
                        Authorization: `Bearer ${ac_token}`,
                    },
                }
            );

            if (response.status !== 200) {
                return {
                    successCount: 0,
                    failCount: 0,
                };
            }

            const processingList = (response.data || []).filter(
                (item) => item.STATUS === "Processing" && item.LINE === targetLine
            );

            if (processingList.length === 0) {
                return {
                    successCount: 0,
                    failCount: 0,
                };
            }

            const results = await Promise.allSettled(
                processingList.map((item) =>
                    axios.put(
                        `${apiUrl.PUT_UPDATE_TUMBLER}${item.CHECK_ON}/`,
                        {
                            status: "Completed",
                            at_completed_timestamp: completeDatetime,
                            username: display,
                        },
                        {
                            headers: {
                                Authorization: `Bearer ${ac_token}`,
                            },
                        }
                    )
                )
            );

            const successCount = results.filter(
                (result) => result.status === "fulfilled"
            ).length;

            const failCount = results.filter(
                (result) => result.status === "rejected"
            ).length;

            console.log("auto completed success:", successCount);
            console.log("auto completed fail:", failCount);

            results.forEach((result, index) => {
                if (result.status === "rejected") {
                    console.log(
                        "auto complete failed item:",
                        processingList[index],
                        result.reason
                    );
                }
            });

            return {
                successCount,
                failCount,
            };
        } catch (error) {
            console.log("auto complete processing error:", error);
            return {
                successCount: 0,
                failCount: 0,
            };
        }
    };

    const handleEditionPause = (event) => {
        const value = event.target.value;
        setHistorySelectedPause(value);
        setSubmitted(false); // 🔥 reset validation
    };

    const handleEditionRemark = (event) => {
        const value = event.target.value;
        setPauseRemark(value);
    };

    const handleEditStatusPause = async () => {
        const targetLine = historyInPause?.LINE || "";

        let payload = {
            country: "Thailand",
            plant_id: plant,
            factory: "00000000000000",
            line: targetLine,
            status: historySelectedPause,
            factory_date: date,
            timestamp: datetime
        };

        if (historySelectedPause === "Breakdown") {
            payload = {
                ...payload,
                status_reason: pauseRemark
            };
        }

        if (pauseRemark) {
            payload = {
                ...payload,
                status_reason: pauseRemark
            };
        }

        try {
            const response = await axios.post(`${apiUrl.PUT_TUMBLER_STATUS}`, payload, {
                headers: {
                    Authorization: `Bearer ${ac_token}`,
                },
            });

            if (response.status == 201) {
                await autoCompleteProcessingByLine(targetLine);
                setEditStatus(1);
                check_update();
                setOpenPopupPause(false);
            }
        } catch (error) {
            setEditStatus(2);
            console.log("edit pause status error:", error);
        }
    };

    const handleEditStatusStop = async () => {
        const targetLine = historyInStop?.LINE || "";

        try {
            const response = await axios.post(`${apiUrl.PUT_TUMBLER_STATUS}`, {
                country: "Thailand",
                plant_id: plant,
                factory: "00000000000000",
                line: targetLine,
                status: "Stop",
                factory_date: date,
                timestamp: datetime
            }, {
                headers: {
                    Authorization: `Bearer ${ac_token}`,
                },
            });

            if (response.status == 201) {
                await autoCompleteProcessingByLine(targetLine);
                setEditStatus(1);
                check_update();
            }
        } catch (error) {
            setEditStatus(2);
            console.log("edit status error:", error);
        }
    };


    useEffect(() => {
        if (popupTimeout === 2) {
            setOpenPopupTimeout(true);
        } else if (popupTimeout === 3) {
            setOpenPopupTimeout(true);
        }
    }, [popupTimeout]);

    useEffect(() => {
        const timer = setInterval(() => {
            setEditStatus(false)
        }, 3000);
        return () => {
            clearInterval(timer);
        };
    }, []);

    const isPauseInvalid =
        !historySelectedPause ||
        (
            isRemarkRequired &&
            !pauseRemark
        );

    const isRemarkError =
        submitted &&
        isRemarkRequired &&
        !pauseRemark;

    return (
        <>
            <Helmet>
                <title>Status Line | MES</title>
            </Helmet>
            {done ? <Circular /> :
                <Box sx={{ width: "100%", padding: 2, backgroundColor: "#f8f9fa" }}>
                    {status_preparation_zone.map((item, index) => {
                        return (
                            <Accordion
                                key={index}
                                sx={{
                                    backgroundColor: "#ffffff",
                                    boxShadow: "0px 3px 6px rgba(0,0,0,0.1)",
                                    borderRadius: "8px",
                                    marginBottom: 1,
                                    transition: "0.3s ease-in-out",
                                    "&:hover": { boxShadow: "0px 5px 10px rgba(0,0,0,0.15)" },
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls={`panel${index}-content`}
                                    id={`panel${index}-header`}
                                    sx={{ padding: "8px 16px" }}
                                >
                                    <Grid container alignItems="center">
                                        <Grid item xs={1} sm={0.5}>
                                            <LensIcon fontSize="small" sx={{ color: item.STATUS == 'Run' ? '#C6E377' : (item.STATUS == 'Changge Product' || item.STATUS == 'Break' || item.STATUS == 'Cleaning' || item.STATUS == 'Material Shortage' || item.STATUS == 'Quality' || item.STATUS == 'RD' || item.STATUS == 'Other') ? '#ffeb3b' : item.STATUS == 'Breakdown' ? '#E8453C' : item.STATUS === 'Minor' ? '#e46c0b' : item.STATUS == 'Stop' ? '#5D5D5D' : '#e2e2e2' }} />
                                        </Grid>
                                        <Grid item xs={3} sm={1}>
                                            <Typography sx={{ fontSize: 16, fontWeight: 'bold' }}>{item.LINE} :</Typography>
                                        </Grid>
                                        <Grid item xs={6} sm={8} textAlign="left" sx={{ paddingTop: 3 }}>
                                            <Typography sx={{ fontSize: 16, fontWeight: 'bold' }}>{item.STATUS == null ? "-" : item.STATUS}</Typography>
                                            <Grid item xs={12}>
                                                <Typography sx={{ fontSize: 14, color: "#777", fontStyle: "italic" }}>
                                                    {item.SKU}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={2} textAlign="right">
                                            <Button
                                                variant="outlined"
                                                sx={{
                                                    width: 32,
                                                    height: 32,
                                                    borderRadius: "50%",
                                                    minWidth: "unset",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    padding: 0,
                                                    fontSize: 14,
                                                    fontWeight: "bold",
                                                    color: "#333",
                                                    borderColor: "#ccc",
                                                    transition: "0.2s ease-in-out",
                                                    "&:hover": { backgroundColor: "#f0f0f0" },
                                                }}
                                            >
                                                {item.SHIFT}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </AccordionSummary>

                                <AccordionDetails sx={{ backgroundColor: "#fafafa", padding: 2 }}>
                                    <Card
                                        sx={{
                                            p: 2,
                                            backgroundColor: "#ffffff",
                                            borderRadius: "8px",
                                            boxShadow: "0px 2px 5px rgba(0,0,0,0.1)",
                                        }}
                                    >
                                        <Grid container spacing={2} justifyContent="center" alignItems="center">
                                            <Grid item xs={4} sm={4} textAlign="center">
                                                <Button
                                                    variant="outlined"
                                                    sx={{
                                                        width: "100%", // ให้ปุ่มขยายเต็มความกว้าง
                                                        padding: "10px",
                                                        fontSize: 14,
                                                        fontWeight: "bold",
                                                        color: "#333",
                                                        borderColor: "#ccc",
                                                        transition: "0.2s ease-in-out",
                                                        "&:hover": { backgroundColor: "#f0f0f0" },
                                                    }}
                                                    disabled={item.STATUS === "Run"}
                                                    onClick={() => { setHistoryInRun({ LINE: item.LINE, SKU: item.SKU, STATUS: item.STATUS }); handleOpenPopupRun(); }}
                                                >
                                                    Run
                                                </Button>
                                            </Grid>

                                            <Grid item xs={4} sm={4} textAlign="center">
                                                <Button
                                                    variant="outlined"
                                                    sx={{
                                                        width: "100%", // ให้ปุ่มขยายเต็มความกว้าง
                                                        padding: "10px",
                                                        fontSize: 14,
                                                        fontWeight: "bold",
                                                        color: "#333",
                                                        borderColor: "#ccc",
                                                        transition: "0.2s ease-in-out",
                                                        "&:hover": { backgroundColor: "#f0f0f0" },
                                                    }}
                                                    disabled={item.STATUS === "Change Product" || item.STATUS === "Break" || item.STATUS === "Cleaning" || item.STATUS === "Material Shortage" || item.STATUS === "Quality" || item.STATUS === "RD" || item.STATUS === "Breakdown" || item.STATUS === "Minor" || item.STATUS === "Other"}
                                                    onClick={() => {
                                                        setHistoryInPause({ LINE: item.LINE, SKU: item.SKU, STATUS: item.STATUS });

                                                        // 🔥 reset ค่า
                                                        setHistorySelectedPause('');
                                                        setPauseRemark('');
                                                        setSubmitted(false);

                                                        handleOpenPopupPause();
                                                    }}
                                                >
                                                    Pause
                                                </Button>
                                            </Grid>

                                            <Grid item xs={4} sm={4} textAlign="center">
                                                <Button
                                                    variant="outlined"
                                                    sx={{
                                                        width: "100%", // ให้ปุ่มขยายเต็มความกว้าง
                                                        padding: "10px",
                                                        fontSize: 14,
                                                        fontWeight: "bold",
                                                        color: "#333",
                                                        borderColor: "#ccc",
                                                        transition: "0.2s ease-in-out",
                                                        "&:hover": { backgroundColor: "#f0f0f0" },
                                                    }}
                                                    disabled={item.STATUS === "Stop"}
                                                    onClick={() => { setHistoryInStop({ LINE: item.LINE, SKU: item.SKU, STATUS: item.STATUS }); handleOpenPopupStop(); }}
                                                >
                                                    Stop
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Card>
                                </AccordionDetails>

                            </Accordion>
                        );
                    })}

                    <Dialog
                        open={openPopupRun}
                        onClose={handleClosePopupRun}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                Do you want to "run" production of {historyInRun?.LINE || ''}?
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button style={{ minWidth: '110px', backgroundColor: '#009688' }} variant="contained" onClick={() => { setOpenPopupRun(false); handleEditStatusRun(); }}>
                                Yes
                            </Button>
                            <Button style={{ minWidth: '110px', backgroundColor: '#575755' }} variant="contained" onClick={() => { setOpenPopupRun(false); }}>
                                No
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog
                        open={openPopupPause}
                        onClose={handleClosePopupPause}
                        fullWidth
                        maxWidth="sm"
                    >
                        <DialogTitle>
                            Pause Detail - Reasons
                        </DialogTitle>

                        <DialogContent>

                            {/* Select Pause */}
                            <FormControl
                                sx={{ m: 1, minWidth: '90%' }}
                                error={submitted && !historySelectedPause}
                            >
                                <InputLabel>Select Pause</InputLabel>
                                <Select
                                    open={openSelectPause}
                                    onClose={handleCloseSelectPause}
                                    onOpen={handleOpenSelectPause}
                                    value={historySelectedPause || ''}
                                    label="Select Pause"
                                    onChange={handleEditionPause}
                                    name="pause"
                                    renderValue={(selected) => (
                                        <Box sx={{ display: "flex", alignItems: "center" }}>
                                            <LensIcon
                                                sx={{
                                                    color: getPauseColor(selected),
                                                    fontSize: 18,
                                                    mr: 1
                                                }}
                                            />
                                            {selected}
                                        </Box>
                                    )}
                                >
                                    {pause_detail.map((item) => (
                                        <MenuItem
                                            key={item.value}
                                            value={item.value}
                                        >
                                            <LensIcon
                                                sx={{
                                                    color: getPauseColor(item.value),
                                                    fontSize: 18,
                                                    mr: 1
                                                }}
                                            />
                                            {item.value}
                                        </MenuItem>
                                    ))}
                                </Select>

                                {submitted && !historySelectedPause && (
                                    <Typography sx={{ color: 'red', fontSize: 12, ml: 1 }}>
                                        Please select pause type
                                    </Typography>
                                )}
                            </FormControl>

                            {/* TextField */}
                            {isRemarkVisible && (
                                <TextField
                                    sx={{ m: 1, width: '90%' }}
                                    label="Detail"
                                    placeholder={
                                        isRemarkRequired
                                            ? "Please specify..."
                                            : "Optional detail..."
                                    }
                                    value={pauseRemark || ""}
                                    onChange={handleEditionRemark}
                                    multiline
                                    rows={2}
                                    error={isRemarkError}
                                    helperText={isRemarkError ? "Please fill detail" : ""}
                                />
                            )}

                        </DialogContent>

                        <DialogActions>
                            <Button
                                disabled={isPauseInvalid}
                                style={{ minWidth: '110px', backgroundColor: '#009688' }}
                                variant="contained"
                                onClick={() => {
                                    setSubmitted(true);
                                    if (isPauseInvalid) return;
                                    handleEditStatusPause();
                                }}
                            >
                                Yes
                            </Button>

                            <Button
                                style={{ minWidth: '110px', backgroundColor: '#575755' }}
                                variant="contained"
                                onClick={() => {
                                    setOpenPopupPause(false);
                                    setSubmitted(false);
                                }}
                            >
                                No
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog
                        open={openPopupStop}
                        onClose={handleClosePopupStop}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                Do you want to "stop" production of {historyInStop?.LINE || ''}?
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button style={{ minWidth: '110px', backgroundColor: '#009688' }} variant="contained" onClick={() => { setOpenPopupStop(false); handleEditStatusStop() }}>
                                Yes
                            </Button>
                            <Button style={{ minWidth: '110px', backgroundColor: '#575755' }} variant="contained" onClick={() => { setOpenPopupStop(false); }}>
                                No
                            </Button>
                        </DialogActions>
                    </Dialog>


                    <Dialog
                        open={openPopupTimeout}
                        onClose={handleClosePopupTimeout}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                {popupTimeout == 2 ? 'No data available' : 'Unable to load data. Please try again.'}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => { handleClosePopupTimeout(); popupTimeout == 2 ? handleClosePopupTimeout() : window.location.reload(false); }} autoFocus>
                                Confirm
                            </Button>
                        </DialogActions>
                    </Dialog>

                    {editStatus === 1 ?
                        <div>
                            <Backdrop
                                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                                open
                            >
                                <Typography style={{ color: '#ffffff', fontWeight: "bold", fontSize: 32, position: "relative" }} textAlign="center">
                                    Successfully editted status
                                </Typography>
                            </Backdrop>
                        </div>
                        : console.log()
                    }
                    {editStatus === 2 ?
                        <div>
                            <Backdrop
                                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                                open
                            >
                                <Typography style={{ color: '#ffffff', fontWeight: "bold", fontSize: 32, position: "relative" }} textAlign="center">
                                    Failed to edit status, Plead try again
                                </Typography>
                            </Backdrop>
                        </div>
                        : console.log()
                    }
                </Box>
            }
        </>
    )
}

export default StatusLineInInfeed
